import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "redux/AxiosClient";

export const createAIMTestAsync = createAsyncThunk(
  "admin/createAIMTest",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/createAIMTest`, payload, toolkit);
  }
);

export const getAllAIMTestAsync = createAsyncThunk(
  "admin/getAllAIMTest",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAllAIMTest?page=${payload.page || ""}&limit=${
        payload.limit || ""
      }&type=${payload.type || ""}&search=${payload.search || ""}`,
      [],
      toolkit
    );
  }
);

export const getAIMTByIdAsync = createAsyncThunk(
  "admin/getAIMTById",
  async (payload, toolkit) => {
    return await AxiosClient("GET", `/getAIMTById/${payload}`, [], toolkit);
  }
);

export const adminLeaderboardsAsync = createAsyncThunk(
  "admin/adminLeaderBoards",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/adminLeaderBoards?testId=${payload?.testId}&goalId=${payload?.goalId}&page=${payload?.page}&limit=${payload?.limit}`,
      payload,
      toolkit
    );
  }
);

export const updateAIMTByIdAsync = createAsyncThunk(
  "admin/updateAIMTById",
  async (payload, toolkit) => {
    return await AxiosClient("PUT", `/updateAIMTById`, payload, toolkit);
  }
);

export const deleteAIMTByIdAsync = createAsyncThunk(
  "admin/deleteAIMTById",
  async (payload, toolkit) => {
    return await AxiosClient(
      "DELETE",
      `/deleteAIMTById/${payload}`,
      [],
      toolkit
    );
  }
);

export const chapterBySubjectIdsAsync = createAsyncThunk(
  "admin/chapterBySubjectIds",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/chapterBySubjectIds`, payload, toolkit);
  }
);
